import { render, staticRenderFns } from "./UserAgreementList.vue?vue&type=template&id=347cc9c0&scoped=true&"
import script from "./UserAgreementList.vue?vue&type=script&lang=ts&"
export * from "./UserAgreementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347cc9c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
